import MessagesCountersRegisters from './messages_counters/MessagesCountersRegisters';
import CountRegister from './messages_counters/messages_counters_register/CountRegister';

export default class MessagesCounters {
  private _backoffice: MessagesCountersRegisters;
  private _frontend: MessagesCountersRegisters;

  constructor(
    backoffice: MessagesCountersRegisters,
    frontend: MessagesCountersRegisters
  ) {
    this._backoffice = backoffice;
    this._frontend = frontend;
  }

  get backoffice(): MessagesCountersRegisters {
    return this._backoffice;
  }

  get frontend(): MessagesCountersRegisters {
    return this._frontend;
  }

  public copyWith({
    backoffice,
    frontend,
  }: {
    backoffice?: MessagesCountersRegisters;
    frontend?: MessagesCountersRegisters;
  }): MessagesCounters {
    return new MessagesCounters(
      backoffice ?? this._backoffice,
      frontend ?? this._frontend
    );
  }

  static fromFirestoreMap(data: Record<string, any>): MessagesCounters {
    const emptyRegisters = () =>
      new MessagesCountersRegisters(new CountRegister(0, 0), new CountRegister(0, 0));
    return new MessagesCounters(
      data.backoffice
        ? MessagesCountersRegisters.fromFirestoreMap(data.backoffice)
        : emptyRegisters(),
      data.frontend
        ? MessagesCountersRegisters.fromFirestoreMap(data.frontend)
        : emptyRegisters()
    );
  }
}
